/**
 * Contact Warranty form (Order inquiry only).
 * - Uploads the screenshot to imgbb and stores the returned URL in a hidden
 *   field so Google Forms only has to store a link, not the binary file.
 * - Submits the rest of the fields straight to the Google Form endpoint.
 *
 */

const IMGBB_API_KEY = '7caf4ccddc9b16c9643fa0d76f9a9c96';
const GOOGLE_FORM_ACTION_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSepUBqdKSJJWKR4VlVNR-rxgXNCWHXi_vVpKOio95NLoFKlFA/formResponse';

const DIAL_CODES = [
  { value: '+1', label: '+1 (Canada & United States)' },
  { value: '+7', label: '+7 (Russia)' },
  { value: '+20', label: '+20 (Egypt)' },
  { value: '+27', label: '+27 (South Africa)' },
  { value: '+30', label: '+30 (Greece)' },
  { value: '+31', label: '+31 (Netherlands)' },
  { value: '+32', label: '+32 (Belgium)' },
  { value: '+33', label: '+33 (France)' },
  { value: '+34', label: '+34 (Spain)' },
  { value: '+36', label: '+36 (Hungary)' },
  { value: '+39', label: '+39 (Italy)' },
  { value: '+40', label: '+40 (Romania)' },
  { value: '+41', label: '+41 (Switzerland)' },
  { value: '+43', label: '+43 (Austria)' },
  { value: '+44', label: '+44 (United Kingdom)' },
  { value: '+45', label: '+45 (Denmark)' },
  { value: '+46', label: '+46 (Sweden)' },
  { value: '+47', label: '+47 (Norway)' },
  { value: '+48', label: '+48 (Poland)' },
  { value: '+49', label: '+49 (Germany)' },
  { value: '+51', label: '+51 (Peru)' },
  { value: '+52', label: '+52 (Mexico)' },
  { value: '+53', label: '+53 (Cuba)' },
  { value: '+54', label: '+54 (Argentina)' },
  { value: '+55', label: '+55 (Brazil)' },
  { value: '+56', label: '+56 (Chile)' },
  { value: '+57', label: '+57 (Colombia)' },
  { value: '+58', label: '+58 (Venezuela)' },
  { value: '+60', label: '+60 (Malaysia)' },
  { value: '+61', label: '+61 (Australia)' },
  { value: '+62', label: '+62 (Indonesia)' },
  { value: '+63', label: '+63 (Philippines)' },
  { value: '+64', label: '+64 (New Zealand)' },
  { value: '+65', label: '+65 (Singapore)' },
  { value: '+66', label: '+66 (Thailand)' },
  { value: '+81', label: '+81 (Japan)' },
  { value: '+82', label: '+82 (South Korea)' },
  { value: '+84', label: '+84 (Vietnam)' },
  { value: '+86', label: '+86 (China)' },
  { value: '+90', label: '+90 (Turkey)' },
  { value: '+91', label: '+91 (India)' },
  { value: '+92', label: '+92 (Pakistan)' },
  { value: '+93', label: '+93 (Afghanistan)' },
  { value: '+94', label: '+94 (Sri Lanka)' },
  { value: '+95', label: '+95 (Myanmar)' },
  { value: '+98', label: '+98 (Iran)' },
  { value: '+211', label: '+211 (South Sudan)' },
  { value: '+212', label: '+212 (Morocco)' },
  { value: '+213', label: '+213 (Algeria)' },
  { value: '+216', label: '+216 (Tunisia)' },
  { value: '+218', label: '+218 (Libya)' },
  { value: '+220', label: '+220 (Gambia)' },
  { value: '+221', label: '+221 (Senegal)' },
  { value: '+222', label: '+222 (Mauritania)' },
  { value: '+223', label: '+223 (Mali)' },
  { value: '+224', label: '+224 (Guinea)' },
  { value: "+225", label: "+225 (Côte d'Ivoire)" },
  { value: '+226', label: '+226 (Burkina Faso)' },
  { value: '+227', label: '+227 (Niger)' },
  { value: '+228', label: '+228 (Togo)' },
  { value: '+229', label: '+229 (Benin)' },
  { value: '+230', label: '+230 (Mauritius)' },
  { value: '+231', label: '+231 (Liberia)' },
  { value: '+232', label: '+232 (Sierra Leone)' },
  { value: '+233', label: '+233 (Ghana)' },
  { value: '+234', label: '+234 (Nigeria)' },
  { value: '+235', label: '+235 (Chad)' },
  { value: '+236', label: '+236 (Central African Republic)' },
  { value: '+237', label: '+237 (Cameroon)' },
  { value: '+238', label: '+238 (Cape Verde)' },
  { value: '+239', label: '+239 (Sao Tome and Principe)' },
  { value: '+240', label: '+240 (Equatorial Guinea)' },
  { value: '+241', label: '+241 (Gabon)' },
  { value: '+242', label: '+242 (Republic of the Congo)' },
  { value: '+243', label: '+243 (Democratic Republic of the Congo)' },
  { value: '+244', label: '+244 (Angola)' },
  { value: '+245', label: '+245 (Guinea-Bissau)' },
  { value: '+248', label: '+248 (Seychelles)' },
  { value: '+249', label: '+249 (Sudan)' },
  { value: '+250', label: '+250 (Rwanda)' },
  { value: '+251', label: '+251 (Ethiopia)' },
  { value: '+252', label: '+252 (Somalia)' },
  { value: '+253', label: '+253 (Djibouti)' },
  { value: '+254', label: '+254 (Kenya)' },
  { value: '+255', label: '+255 (Tanzania)' },
  { value: '+256', label: '+256 (Uganda)' },
  { value: '+257', label: '+257 (Burundi)' },
  { value: '+258', label: '+258 (Mozambique)' },
  { value: '+260', label: '+260 (Zambia)' },
  { value: '+261', label: '+261 (Madagascar)' },
  { value: '+263', label: '+263 (Zimbabwe)' },
  { value: '+264', label: '+264 (Namibia)' },
  { value: '+265', label: '+265 (Malawi)' },
  { value: '+266', label: '+266 (Lesotho)' },
  { value: '+267', label: '+267 (Botswana)' },
  { value: '+268', label: '+268 (Swaziland)' },
  { value: '+269', label: '+269 (Comoros)' },
  { value: '+291', label: '+291 (Eritrea)' },
  { value: '+350', label: '+350 (Gibraltar)' },
  { value: '+351', label: '+351 (Portugal)' },
  { value: '+352', label: '+352 (Luxembourg)' },
  { value: '+353', label: '+353 (Ireland)' },
  { value: '+354', label: '+354 (Iceland)' },
  { value: '+355', label: '+355 (Albania)' },
  { value: '+356', label: '+356 (Malta)' },
  { value: '+357', label: '+357 (Cyprus)' },
  { value: '+358', label: '+358 (Finland)' },
  { value: '+359', label: '+359 (Bulgaria)' },
  { value: '+370', label: '+370 (Lithuania)' },
  { value: '+371', label: '+371 (Latvia)' },
  { value: '+372', label: '+372 (Estonia)' },
  { value: '+373', label: '+373 (Moldova)' },
  { value: '+374', label: '+374 (Armenia)' },
  { value: '+375', label: '+375 (Belarus)' },
  { value: '+376', label: '+376 (Andorra)' },
  { value: '+377', label: '+377 (Monaco)' },
  { value: '+378', label: '+378 (San Marino)' },
  { value: '+380', label: '+380 (Ukraine)' },
  { value: '+381', label: '+381 (Serbia)' },
  { value: '+382', label: '+382 (Montenegro)' },
  { value: '+385', label: '+385 (Croatia)' },
  { value: '+386', label: '+386 (Slovenia)' },
  { value: '+387', label: '+387 (Bosnia and Herzegovina)' },
  { value: '+389', label: '+389 (Macedonia)' },
  { value: '+420', label: '+420 (Czech Republic)' },
  { value: '+421', label: '+421 (Slovakia)' },
  { value: '+423', label: '+423 (Liechtenstein)' },
  { value: '+501', label: '+501 (Belize)' },
  { value: '+502', label: '+502 (Guatemala)' },
  { value: '+503', label: '+503 (El Salvador)' },
  { value: '+504', label: '+504 (Honduras)' },
  { value: '+505', label: '+505 (Nicaragua)' },
  { value: '+506', label: '+506 (Costa Rica)' },
  { value: '+507', label: '+507 (Panama)' },
  { value: '+509', label: '+509 (Haiti)' },
  { value: '+591', label: '+591 (Bolivia)' },
  { value: '+592', label: '+592 (Guyana)' },
  { value: '+593', label: '+593 (Ecuador)' },
  { value: '+595', label: '+595 (Paraguay)' },
  { value: '+597', label: '+597 (Suriname)' },
  { value: '+598', label: '+598 (Uruguay)' },
  { value: '+673', label: '+673 (Brunei)' },
  { value: '+675', label: '+675 (Papua New Guinea)' },
  { value: '+676', label: '+676 (Tonga Islands)' },
  { value: '+679', label: '+679 (Fiji)' },
  { value: '+850', label: '+850 (North Korea)' },
  { value: '+852', label: '+852 (Hong Kong)' },
  { value: '+853', label: '+853 (Macau)' },
  { value: '+855', label: '+855 (Cambodia)' },
  { value: '+856', label: '+856 (Laos)' },
  { value: '+880', label: '+880 (Bangladesh)' },
  { value: '+886', label: '+886 (Taiwan)' },
  { value: '+960', label: '+960 (Maldives)' },
  { value: '+961', label: '+961 (Lebanon)' },
  { value: '+962', label: '+962 (Jordan)' },
  { value: '+963', label: '+963 (Syria)' },
  { value: '+964', label: '+964 (Iraq)' },
  { value: '+965', label: '+965 (Kuwait)' },
  { value: '+966', label: '+966 (Saudi Arabia)' },
  { value: '+967', label: '+967 (Yemen)' },
  { value: '+968', label: '+968 (Oman)' },
  { value: '+970', label: '+970 (Palestine)' },
  { value: '+971', label: '+971 (United Arab Emirates)' },
  { value: '+972', label: '+972 (Israel)' },
  { value: '+973', label: '+973 (Bahrain)' },
  { value: '+974', label: '+974 (Qatar)' },
  { value: '+975', label: '+975 (Bhutan)' },
  { value: '+976', label: '+976 (Mongolia)' },
  { value: '+977', label: '+977 (Nepal)' },
  { value: '+992', label: '+992 (Tajikistan)' },
  { value: '+993', label: '+993 (Turkmenistan)' },
  { value: '+994', label: '+994 (Azerbaijan)' },
  { value: '+995', label: '+995 (Georgia)' },
  { value: '+996', label: '+996 (Kyrgyzstan)' },
  { value: '+998', label: '+998 (Uzbekistan)' },
];

const COUNTRIES = [
  'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Argentina', 'Armenia', 'Australia',
  'Austria', 'Azerbaijan', 'Bahrain', 'Bangladesh', 'Belarus', 'Belgium', 'Belize', 'Benin',
  'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei Darussalam',
  'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde',
  'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros',
  'Congo - Brazzaville', 'Congo - Kinshasa', 'Costa Rica', "Côte d'Ivoire", 'Croatia', 'Cuba',
  'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominican Republic', 'Ecuador', 'Egypt',
  'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Eswatini', 'Ethiopia', 'Fiji',
  'Finland', 'France', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Guatemala',
  'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland',
  'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy', 'Jamaica', 'Japan',
  'Jordan', 'Kazakhstan', 'Kenya', 'Kosovo', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon',
  'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau',
  'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Mauritania', 'Mauritius',
  'Mexico', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Morocco', 'Mozambique', 'Myanmar',
  'Namibia', 'Nepal', 'Netherlands', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria',
  'North Korea', 'North Macedonia', 'Norway', 'Oman', 'Pakistan', 'Palestine', 'Panama',
  'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Puerto Rico',
  'Qatar', 'Republic of Korea', 'Romania', 'Russia', 'Rwanda', 'San Marino', 'Saudi Arabia',
  'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia',
  'Somalia', 'South Africa', 'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Sweden',
  'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Togo', 'Tonga',
  'Tunisia', 'Turkey', 'Turkmenistan', 'Uganda', 'Ukraine', 'United Arab Emirates',
  'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Venezuela', 'Vietnam', 'Yemen',
  'Zambia', 'Zimbabwe',
];

const LANGUAGES = [
  { value: 'English', label: 'English' },
  { value: 'Malay', label: 'Malay' },
];

function populateSelect(select, options, defaultValue) {
  options.forEach((option) => {
    const { value, label } = typeof option === 'string' ? { value: option, label: option } : option;
    const el = document.createElement('option');
    el.value = value;
    el.textContent = label;
    if (value === defaultValue) el.selected = true;
    select.appendChild(el);
  });
}

function setGroupVisible(group, visible) {
  if (!group) return;
  group.classList.toggle('contact-warranty-form__field--hidden', !visible);
  group.querySelectorAll('[data-required-when-visible]').forEach((field) => {
    if (visible && isFieldActive(field, field.closest('form'))) {
      field.setAttribute('required', 'required');
    } else {
      field.removeAttribute('required');
    }
  });
}

function isFieldActive(field, form) {
  let node = field;
  while (node && node !== form) {
    if (node.classList && node.classList.contains('contact-warranty-form__field--hidden')) {
      return false;
    }
    node = node.parentElement;
  }
  return true;
}

function getFieldLabel(field) {
  const label = field.querySelector('label');
  return label ? label.textContent.replace('*', '').trim() : 'image';
}

async function uploadAllImages(form) {
  const imageFields = form.querySelectorAll('[data-image-field]');

  for (const field of imageFields) {
    const input = field.querySelector('[data-image-input]');
    const urlInput = field.querySelector('[data-image-url]');
    const statusEl = field.querySelector('[data-image-status]');
    if (!input) continue;

    if (!isFieldActive(field, form)) {
      input.value = '';
      if (urlInput) urlInput.value = '';
      if (statusEl) clearMessage(statusEl);
      continue;
    }

    const file = input.files[0];
    if (!file) {
      if (input.required || input.hasAttribute('data-required-when-visible')) {
        throw new Error(`Please upload: ${getFieldLabel(field)}`);
      }
      if (urlInput) urlInput.value = '';
      continue;
    }

    if (statusEl) showMessage(statusEl, 'uploading', 'Uploading…');
    const imageUrl = await uploadScreenshotToImgbb(file);
    if (urlInput) urlInput.value = imageUrl;
    if (statusEl) showMessage(statusEl, 'success', 'Uploaded.');
  }
}

async function uploadScreenshotToImgbb(file) {
  const body = new FormData();
  body.append('image', file);

  const response = await fetch(`https://api.imgbb.com/1/upload?key=${IMGBB_API_KEY}`, {
    method: 'POST',
    body,
  });

  if (!response.ok) {
    throw new Error('Could not upload the screenshot. Please try again.');
  }

  const data = await response.json();
  if (!data || !data.data || !data.data.url) {
    throw new Error('Could not upload the screenshot. Please try again.');
  }

  const url = new URL(data.data.url);
  url.hostname = url.hostname.replace(/ibb\.co$/, 'ibb.co.com');
  return url.toString();
}

function showMessage(messageEl, state, text) {
  messageEl.textContent = text;
  messageEl.setAttribute('data-state', state);
}

function clearMessage(messageEl) {
  messageEl.textContent = '';
  messageEl.removeAttribute('data-state');
}

function initContactWarrantyForm(form) {
  const dialCodeSelect = form.querySelector('[data-field="dial-code"]');
  const countrySelect = form.querySelector('[data-field="country"]');
  const languageSelect = form.querySelector('[data-field="language"]');
  const inquirySelect = form.querySelector('[data-field="inquiry"]');
  const orderInquiryGroup = form.querySelector('[data-inquiry-group="Order"]');
  const warrantyInquiryGroup = form.querySelector('[data-inquiry-group="Warranty"]');
  const productInquiryGroup = form.querySelector('[data-inquiry-group="Product"]');
  const accountInquiryGroup = form.querySelector('[data-inquiry-group="Account"]');
  const websiteInquiryGroup = form.querySelector('[data-inquiry-group="Website"]');
  const returnInquiryGroup = form.querySelector('[data-inquiry-group="Return"]');
  const otherInquiryGroup = form.querySelector('[data-inquiry-group="Other"]');
  const helpSelect = form.querySelector('[data-field="help-topic"]');
  const helpGroups = form.querySelectorAll('[data-help-group]');
  const websiteHelpSelect = form.querySelector('[data-field="website-help-topic"]');
  const websiteHelpGroups = form.querySelectorAll('[data-website-group]');
  const otherHelpSelect = form.querySelector('[data-field="other-help-topic"]');
  const otherHelpGroups = form.querySelectorAll('[data-other-group]');
  const actionRadios = form.querySelectorAll('[data-field="choose-action"]');
  const cancellationReasonGroup = form.querySelector('[data-conditional="cancellation-reason"]');
  const packageDamagedSelect = form.querySelector('[data-field="package-damaged"]');
  const packageConditionGroup = form.querySelector('[data-conditional="package-condition"]');
  const submitButton = form.querySelector('[data-submit-button]');
  const messageEl = form.querySelector('[data-form-message]');

  populateSelect(dialCodeSelect, DIAL_CODES, '+60');
  populateSelect(countrySelect, COUNTRIES, 'Malaysia');
  populateSelect(languageSelect, LANGUAGES, 'English');

  function updateInquiry() {
    const isInquiryOrder = !inquirySelect || inquirySelect.value === 'Order';
    const isInquiryWarranty = !!inquirySelect && inquirySelect.value === 'Warranty';
    const isInquiryProduct = !!inquirySelect && inquirySelect.value === 'Product';
    const isInquiryAccount = !!inquirySelect && inquirySelect.value === 'Account';
    const isInquiryWebsite = !!inquirySelect && inquirySelect.value === 'Website';
    const isInquiryReturn = !!inquirySelect && inquirySelect.value === 'Return';
    const isInquiryOther = !!inquirySelect && inquirySelect.value === 'Other';

    setGroupVisible(orderInquiryGroup, isInquiryOrder);
    setGroupVisible(warrantyInquiryGroup, isInquiryWarranty);
    setGroupVisible(productInquiryGroup, isInquiryProduct);
    setGroupVisible(accountInquiryGroup, isInquiryAccount);
    setGroupVisible(websiteInquiryGroup, isInquiryWebsite);
    setGroupVisible(returnInquiryGroup, isInquiryReturn);
    setGroupVisible(otherInquiryGroup, isInquiryOther);

    if (isInquiryOrder) {
      updateHelpGroups();
      updateCancellationReason();
      updatePackageCondition();
    }
    if (isInquiryWebsite) {
      updateWebsiteHelpGroups();
    }
    if (isInquiryOther) {
      updateOtherHelpGroups();
    }
  }

  function updateHelpGroups() {
    if (inquirySelect && inquirySelect.value !== 'Order') {
      helpGroups.forEach((group) => setGroupVisible(group, false));
      return;
    }
    helpGroups.forEach((group) => {
      const values = (group.dataset.helpGroup || '').split(',').map((value) => value.trim());
      setGroupVisible(group, helpSelect && values.includes(helpSelect.value));
    });
  }

  function updateWebsiteHelpGroups() {
    if (inquirySelect && inquirySelect.value !== 'Website') {
      websiteHelpGroups.forEach((group) => setGroupVisible(group, false));
      return;
    }
    websiteHelpGroups.forEach((group) => {
      const values = (group.dataset.websiteGroup || '').split(',').map((value) => value.trim());
      setGroupVisible(group, websiteHelpSelect && values.includes(websiteHelpSelect.value));
    });
  }

  function updateOtherHelpGroups() {
    if (inquirySelect && inquirySelect.value !== 'Other') {
      otherHelpGroups.forEach((group) => setGroupVisible(group, false));
      return;
    }
    otherHelpGroups.forEach((group) => {
      const values = (group.dataset.otherGroup || '').split(',').map((value) => value.trim());
      setGroupVisible(group, otherHelpSelect && values.includes(otherHelpSelect.value));
    });
  }

  function updateCancellationReason() {
    if (inquirySelect && inquirySelect.value !== 'Order') {
      setGroupVisible(cancellationReasonGroup, false);
      return;
    }
    const checked = form.querySelector('[data-field="choose-action"]:checked');
    setGroupVisible(cancellationReasonGroup, !!checked && checked.value === 'Cancel');
  }

  function updatePackageCondition() {
    if (inquirySelect && inquirySelect.value !== 'Order') {
      setGroupVisible(packageConditionGroup, false);
      return;
    }
    setGroupVisible(packageConditionGroup, !!packageDamagedSelect && packageDamagedSelect.value === 'Yes');
  }

  if (inquirySelect) {
    inquirySelect.addEventListener('change', updateInquiry);
  }
  if (helpSelect) {
    helpSelect.addEventListener('change', updateHelpGroups);
  }
  if (websiteHelpSelect) {
    websiteHelpSelect.addEventListener('change', updateWebsiteHelpGroups);
  }
  if (otherHelpSelect) {
    otherHelpSelect.addEventListener('change', updateOtherHelpGroups);
  }
  actionRadios.forEach((radio) => radio.addEventListener('change', updateCancellationReason));
  if (packageDamagedSelect) {
    packageDamagedSelect.addEventListener('change', updatePackageCondition);
  }

  updateInquiry();

  form.querySelectorAll('[data-image-input]').forEach((input) => {
    input.addEventListener('change', () => {
      const field = input.closest('[data-image-field]');
      const statusEl = field ? field.querySelector('[data-image-status]') : null;
      if (!statusEl) return;
      if (input.files[0]) {
        showMessage(statusEl, 'default', input.files[0].name);
      } else {
        clearMessage(statusEl);
      }
    });
  });

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    clearMessage(messageEl);

    submitButton.disabled = true;

    try {
      await uploadAllImages(form);

      const payload = new FormData();
      form.querySelectorAll('[name^="entry."]').forEach((field) => {
        if (!isFieldActive(field, form)) return;

        if (field.type === 'radio' || field.type === 'checkbox') {
          if (field.checked) payload.append(field.name, field.value);
        } else if (field.type !== 'file') {
          payload.append(field.name, field.value);
        }
      });

      await fetch(GOOGLE_FORM_ACTION_URL, {
        method: 'POST',
        mode: 'no-cors',
        body: payload,
      });

      showMessage(messageEl, 'success', "Thank you! We've received your request.");
      form.reset();
      dialCodeSelect.innerHTML = '';
      countrySelect.innerHTML = '';
      languageSelect.innerHTML = '';
      populateSelect(dialCodeSelect, DIAL_CODES, '+60');
      populateSelect(countrySelect, COUNTRIES, 'Malaysia');
      populateSelect(languageSelect, LANGUAGES, 'English');
      if (inquirySelect) inquirySelect.value = 'Order';
      updateInquiry();
      form.querySelectorAll('[data-image-status]').forEach(clearMessage);
    } catch (error) {
      showMessage(messageEl, 'error', error.message || 'Something went wrong. Please try again.');
    } finally {
      submitButton.disabled = false;
    }
  });
}

document.querySelectorAll('[data-contact-warranty-form]').forEach(initContactWarrantyForm);
